<template>
  <div class="modal-backdrop" @click.self="close">
    <div class="modal-box fade-in">

      <!-- Header -->
      <div class="modal-header">
        <h3>{{ isEdit ? "Edit Team Member" : "Add New Team Member" }}</h3>
        <button class="close-btn" @click="close">
          <i class="bx bx-x"></i>
        </button>
      </div>

      <!-- Form -->
      <div class="modal-body">

        <!-- First Name -->
        <div class="form-group">
          <label>First Name</label>
          <input
            type="text"
            v-model="formData.fname"
            placeholder="Enter first name"
          />
        </div>

        <!-- Last Name -->
        <div class="form-group">
          <label>Last Name</label>
          <input
            type="text"
            v-model="formData.lname"
            placeholder="Enter last name"
          />
        </div>

        <!-- Email -->
        <div class="form-group">
          <label>Email</label>
          <input
            type="email"
            v-model="formData.email"
            placeholder="Enter email address"
          />
        </div>

        <!-- Mobile -->
        <div class="form-group">
          <label>Mobile Number</label>
          <input
            type="text"
            v-model="formData.mobile"
            placeholder="Enter mobile number"
          />
        </div>

        <!-- Password (only for ADD) -->
        <div class="form-group" v-if="!isEdit">
          <label>Password</label>
          <input
            type="password"
            v-model="formData.password"
            placeholder="Create password"
          />
        </div>

        <!-- Status -->
        <div class="form-group">
          <label>Status</label>
          <select v-model="formData.status">
            <option value="1">Active</option>
            <option value="leave">On Leave</option>
            <option value="0">Deactivated</option>
          </select>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn-secondary" @click="close">
          Cancel
        </button>

        <button class="btn-primary" @click="submitForm">
          {{ isEdit ? "Update" : "Save Member" }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  name: "TeamMemberModal",

  props: {
    form: Object,
    isEdit: Boolean,
  },

  emits: ["close", "save"],

  data() {
    return {
      toast: useToast(),

      formData: {
        user_id: "",
        fname: "",
        lname: "",
        email: "",
        mobile: "",
        password: "",
        status: "1",
      },
    };
  },

  mounted() {
    this.formData = { ...this.form };
  },

  methods: {
    close() {
      this.$emit("close");
    },

    submitForm() {
      if (!this.formData.fname.trim())
        return this.toast.warning("First name is required");

      if (!this.formData.lname.trim())
        return this.toast.warning("Last name is required");

      if (!this.formData.email.trim())
        return this.toast.warning("Email is required");

      if (!this.formData.mobile.trim())
        return this.toast.warning("Mobile number is required");

      if (!this.isEdit && !this.formData.password.trim())
        return this.toast.warning("Password is required");

      this.$emit("save", this.formData);
    },
  },
};
</script>

<style scoped>
/* Backdrop */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

/* Modal */
.modal-box {
  background: #fff;
  width: 420px;
  max-width: 95%;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid var(--border);
  animation: popup 0.25s ease;
}

/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.modal-header h3 {
  font-size: 18px;
  font-weight: 700;
}
.close-btn {
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

/* Form */
.form-group {
  margin-bottom: 14px;
}
label {
  font-size: 13px;
  font-weight: 600;
  display: block;
  margin-bottom: 6px;
}
input,
select {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}
input:focus,
select:focus {
  border-color: var(--primary);
}

/* Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
.btn-secondary {
  background: #f3f4f6;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}
.btn-primary {
  background: var(--primary);
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}

/* Animations */
@keyframes popup {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
